<div class="conflict-modal-container">
  <div class="conflict-header">Advertiser domains already assigned</div>
  <div class="conflict-description">
    Some of the domains you added are already assigned to other brands.
    Review and confirm if you also want to add them to {{ data.brandName }}.
  </div>
  <div class="conflict-table-wrapper">
    <table class="conflict-table">
      <thead>
        <tr>
          <th>Advertiser Domain</th>
          <th>Existing Brand(s)</th>
        </tr>
      </thead>
      <tbody>
        @for (conflict of data.conflicts; track conflict.domain) {
          <tr>
            <td>
              <span class="domain-chip">{{ conflict.domain }}</span>
            </td>
            <td>{{ formatBrands(conflict.brands) }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  <div class="conflict-buttons">
    <app-button text="Back to editing" class="secondary" (clicked)="goBack()"></app-button>
    <app-button text="Confirm and save" class="primary" (clicked)="confirm()"></app-button>
  </div>
</div>
